import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import useSWR from 'swr';
import { TaskViewType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import { Box } from '@yoweb/ui/components/Box';
import { Summary } from '@poplar/components/Questions/Summary';
import { ErrorDisplay, useError } from '@yoweb/ui/components/form';
import { StepsBottomPanel } from '@poplar/components/tasks/CreateTodoFlyout/StepsBottomPanel';
import { Grid } from '@yoweb/ui/components/Grid';
import { Title } from '@yoweb/ui/components/typography';
import { useTranslation } from '@yoweb/next-i18next';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useUser } from '@poplar/hooks/useUser';
import { API_TASKS_INTERACTION_CONTROLS } from '@poplar/constants/routes';
import { fetcher } from '@yoweb/utils/common';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { isTaskRecurring } from '@poplar/utils/tasks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IntakeSummary = function IntakeSummary(_ref) {
  var questionsList = _ref.questionsList,
      onSaveDraft = _ref.onSaveDraft,
      onHandoff = _ref.onHandoff,
      initialTask = _ref.initialTask,
      pathOfBranchingQuestions = _ref.pathOfBranchingQuestions,
      isSubscriptionFlow = _ref.isSubscriptionFlow,
      taskTemplateId = _ref.taskTemplateId;
  var errorDisplay = useError();

  var _useState = useState(false),
      isSavingDraft = _useState[0],
      setIsSavingDraft = _useState[1];

  var _useState2 = useState(false),
      isHandingOff = _useState2[0],
      setIsHandingOff = _useState2[1];

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useExternalConfig = useExternalConfig(),
      enablePrimeProPreview = _useExternalConfig.globalFeatures.enablePrimeProPreview;

  var user = useUser();

  var _useSWR = useSWR(user.isAuthenticated && taskTemplateId ? API_TASKS_INTERACTION_CONTROLS(initialTask === null || initialTask === void 0 ? void 0 : initialTask.taskId, taskTemplateId) : undefined, fetcher, {
    shouldRetryOnError: false
  }),
      taskInteractionControls = _useSWR.data;

  var allowPreviewHandoff = enablePrimeProPreview && (taskInteractionControls === null || taskInteractionControls === void 0 ? void 0 : taskInteractionControls.allowHandoff);
  var isRecurring = isTaskRecurring(questionsList);

  var saveDraft = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsSavingDraft(true);
              _context.prev = 1;
              errorDisplay.clear();
              _context.next = 5;
              return onSaveDraft();

            case 5:
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              errorDisplay.set();
              throw _context.t0;

            case 11:
              _context.prev = 11;
              setIsSavingDraft(false);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7, 11, 14]]);
    }));

    return function saveDraft() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handOff = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsHandingOff(true);
              _context2.prev = 1;
              errorDisplay.clear();

              if (isRecurring) {
                trackEvent({
                  recurringTaskCreation: {}
                });
              }

              _context2.next = 6;
              return onHandoff();

            case 6:
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              errorDisplay.set();
              throw _context2.t0;

            case 12:
              _context2.prev = 12;
              setIsHandingOff(false);
              return _context2.finish(12);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8, 12, 15]]);
    }));

    return function handOff() {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Box, {
    height: "100%",
    "data-testid": "intake-summary-view",
    children: /*#__PURE__*/_jsxs(Grid, {
      rowGap: "normal2",
      height: "100%",
      rows: errorDisplay.error ? 'auto 1fr' : 'auto',
      children: [/*#__PURE__*/_jsx(ErrorDisplay, _objectSpread(_objectSpread({
        withBorder: true,
        scrollTo: true
      }, errorDisplay), {}, {
        "data-testid": "error-banner"
      })), /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        children: [/*#__PURE__*/_jsxs(Grid, {
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            children: t('todo-intake.summary.title')
          }), /*#__PURE__*/_jsx(Summary, {
            taskView: initialTask ? initialTask.taskView : TaskViewType.TASK_VIEW_TYPE_UNSPECIFIED,
            questions: questionsList.filter(function (_question, index) {
              return pathOfBranchingQuestions.includes(index + 1);
            })
          })]
        }), /*#__PURE__*/_jsx(StepsBottomPanel, {
          onSaveDraft: saveDraft,
          isDraftDisabled: isSavingDraft || isHandingOff,
          isDraftLoading: isSavingDraft,
          onSubmit: handOff,
          isSubmitLoading: isHandingOff,
          isSubmitDisabled: isSavingDraft || isHandingOff,
          submitBtnLabel: "todo-intake.hand-off",
          initialTask: initialTask,
          isSummaryStep: true,
          disableUpsellBanner: allowPreviewHandoff || isSubscriptionFlow,
          allowPreviewHandoff: allowPreviewHandoff
        })]
      })]
    })
  });
};